import _ from 'lodash'
import { BotFeatures } from '@feedyou-ai/feedbot-schema'
import { ForcedBotFeatures } from './devToolsSlice'

export const applyForcedBotFeatures = (
  features: BotFeatures[],
  forcedFeatures: ForcedBotFeatures
): BotFeatures[] => {
  const forceEnabled = Object.entries(forcedFeatures)
    .filter(([, value]) => value)
    .map(([key]) => key)

  const forceDisabled = Object.entries(forcedFeatures)
    .filter(([, value]) => !value)
    .map(([key]) => key)

  return _.difference(
    [...features, ...forceEnabled], // I <3 PRETTIER
    forceDisabled
  ) as BotFeatures[]
}
